import React, { useState, useEffect } from 'react';
import CustomDialog from '../../../shared/components/CustomDialog';
import Button from '../../../shared/components/Button';
import CustomSelect from '../../../shared/components/CustomSelect/CustomSelect';
import styles from '../../pages/GpsDetails/modalChangeSim.module.scss';

const ModalResetSimcard = ({
  open,
  onClose,
  simcard,
  getSimcardsSubstatusesRequest,
  substatuses,
  fetchingSubstatuses,
  patchSimcardsBatchRequest,
  getSimCardsRequest,
  setSimcardSelected,
  iccid
}) => {
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      getSimcardsSubstatusesRequest({ codeStatus: 'bodega' });
      setSelectedWarehouse(null);
      setError(null);
    }
  }, [open, getSimcardsSubstatusesRequest]);

  useEffect(() => {
    if (substatuses && Array.isArray(substatuses)) {
      const options = substatuses.map(substatus => ({
        value: substatus._id,
        label: substatus.name,
        referenceModel: substatus.referenceModel,
        referenceId: substatus.referenceId
      }));
      setWarehouseOptions(options);
    }
  }, [substatuses]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedWarehouse) return;

    setIsSubmitting(true);
    setError(null);

    try {
      const updatePayload = {
        iccids: [simcard?.iccid],
        data: {
          status: 'bodega',
          substatus: {
            referenceModel: selectedWarehouse.referenceModel,
            referenceId: selectedWarehouse.value
          }
        }
      };

      await patchSimcardsBatchRequest(updatePayload, { skipListReload: true });

      setTimeout(() => {
        getSimCardsRequest({
          iccid: simcard?.iccid,
          full_status: 1,
          limit: 50,
          page: 1
        });
      }, 500);

      onClose();
    } catch (err) {
      setError('Hubo un error al resetear la simcard.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const isValid = selectedWarehouse !== null;

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      dialogTitle="Resetear Simcard"
      className={styles.modal}
      dialogActions={
        <div className={styles.actions}>
          <div className={styles.cancelButton}>
            <Button onClick={onClose}>Cancelar</Button>
          </div>
          <Button
            className={styles.saveButton}
            onClick={handleSubmit}
            disabled={!isValid || isSubmitting || fetchingSubstatuses}
          >
            {isSubmitting ? 'Guardando...' : 'Guardar'}
          </Button>
        </div>
      }
    >
      <form className={styles.content}>
        <div className={styles.newCardSection}>
          <p style={{ marginBottom: '2px', fontSize: '14px'}}>
            Estás a punto de resetear esta simcard. 
          </p>
          <p style={{ marginBottom: '30px', fontSize: '14px'}}>
           Elige la bodega a la que quieres enviarla:
          </p>

          <div className={styles.formGroup}>
            <CustomSelect
              options={warehouseOptions}
              value={selectedWarehouse}
              onChange={setSelectedWarehouse}
              placeholder="Selecciona una bodega"
              isDisabled={fetchingSubstatuses}
              loading={fetchingSubstatuses}
              className={styles.selectWarehouse}
            />
          </div>
   
          {error && <div className={styles.errorText}>{error}</div>}
        </div>
      </form>
    </CustomDialog>
  );
};

export default ModalResetSimcard;
